import { PAGE_REQUEST } from 'store/app/types';

import { types } from './actions';

const initialState = {
  isLoggingIn: false,
  twoFactorLoginError: null,
  hasReceivedCredentials: false,
};

const reducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case PAGE_REQUEST:
      return initialState;
    case types.LOGIN_TWO_FACTOR_REQUEST:
      return { ...state, isLoggingIn: true };
    case types.LOGIN_TWO_FACTOR_SUCCESS: {
      return {
        ...state,
        isLoggingIn: false,
      };
    }
    case types.LOGIN_TWO_FACTOR_ERROR:
      return {
        ...state,
        twoFactorLoginError: payload.error,
        isLoggingIn: false,
      };
    case types.INIT_TWO_FACTOR_AUTHENTICATION:
      return {
        ...state,
        hasReceivedCredentials: true,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.auth.twoFactorAuthentication;

export const getError = (state) => getScope(state).twoFactorLoginError;

export const getIsLoggingIn = (state) => getScope(state).isLoggingIn;

export const getHasReceivedCredentials = (state) =>
  getScope(state).hasReceivedCredentials;
